module.exports = __webpack_public_path__ + "static/img/re.36610173.svg";